//  Version : 0.0.1
//  Author : VISHNU
// LastEdit : KARTHEESWARAN
// LASTADD : Removed excel Redux
// MODFIED DATE:12-11-2025

const ArrearFollowupActionTypes = {
	/*************** GET ARREAR FOLLOWUP LIST START ************/
	GET_ARREAR_FOLLOWUP_LIST_START: 'get_arrear_followup_start',
	GET_ARREAR_FOLLOWUP_LIST_SUCCESS: 'get_arrear_followup_success',
	GET_ARREAR_FOLLOWUP_LIST_FAILURE: 'get_arrear_followup_failure',
	GET_ARREAR_FOLLOWUP_LIST_RESPONSE_RESET: 'get_arrear_followup_response_reset',
	GET_ARREAR_FOLLOWUP_LIST_RESPONSE_CHANGED: 'get_arrear_followup_response_changed',
	/*************** GET ARREAR FOLLOWUP LIST END ************/
};
export default ArrearFollowupActionTypes;
